namespace Areas.Polarities {
    "use strict";

    //
    //CRUD functions
    //

    var formPolarityOpen, formPolarityClose;


    var formCrudOps: FormCrudOperations;
    $(() => { init(); });

    function init() {

        formCrudOps = new FormCrudOperations("Polarities");
        formPolarityOpen = new UpdateOperations("PolaritiesForm", "/Polarities/Edit/OpenPolarity");
        formPolarityClose = new UpdateOperations("PolaritiesForm","/Polarities/Edit/ClosePolarity");
    }

    export function openPolarity(e: any) {
        formPolarityOpen.updateRecordWithId();
    }

    export function closePolarity(e: any) {
        formPolarityClose.updateRecordWithId();
    }

    export function insertRecord(e: any) {
        formCrudOps.insertRecord();
    }

    export function updateRecord(e: any) {
        formCrudOps.updateRecord();
    }

    export function voidRecord() {
        const verifyVoid = window.confirm("Are you sure you would like to VOID this record?");

        if (verifyVoid) {
            const form = $("#PolaritiesForm").dxForm("instance");
            const keyId: any = form.option("KeyId");
            const projectId = form.option("ProjectId");

            if (keyId != null && projectId != null) {
                sendRequest(`/Polarities/Edit/VoidPolarity/${keyId}/${projectId}/`, "", "PUT");
            }
        }
    }



}
